<style scoped>
  .task-user {
    cursor: pointer;
  }
</style>

<template>
  <user-select v-bind="$attrs" @change="onChange">
    <div class="task-user">{{name ? name : '未指定'}} <i class="fmico fmico-paixu-jiangxu" style="margin-left: 5px;"></i></div>
  </user-select>
</template>

<script>
import UserSelect from '../select/user'

export default {
  inheritAttrs: false,
  components: { UserSelect },
  props: {
    id: { type: Number, default: null }
  },
  data () {
    return {
      currentId: this.id
    }
  },
  watch: {
    id (id) {
      this.currentId = id
    }
  },
  computed: {
    current () {
      return this.currentId ? this.userList.find(v => v.key === this.currentId) : null
    },
    name () {
      return this.current ? this.current.label : null
    },
    userList () {
      return this.$store.getters.userList
    }
  },
  methods: {
    onChange (v) {
      this.currentId = v
      this.$emit('change', v)
    }
  }
}
</script>
